import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

/**
 * Content-first case study row. Text + metrics led, no decorative imagery.
 */
export const CaseStudyRow = ({ study, index }) => {
  return (
    <Link
      to={`/work/${study.slug}`}
      data-testid={`case-study-card-${study.slug}`}
      className="group grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-8 items-start border-t border-white/10 py-9 md:py-11 hover:bg-white/[0.02] transition-colors"
    >
      <div className="md:col-span-1">
        <span className="font-heading text-sm text-ash tabular-nums">{index}</span>
      </div>

      <div className="md:col-span-7">
        <div className="flex flex-wrap items-center gap-3 text-xs text-ash mb-3">
          <span className="rounded-full border border-white/15 px-2.5 py-0.5 text-cream/75">{study.category}</span>
          <span>{study.year}</span>
          <span>·</span>
          <span>{study.role}</span>
        </div>
        <h3 className="font-heading text-2xl md:text-3xl tracking-tight text-cream group-hover:text-white transition-colors inline-flex items-center gap-3">
          {study.title}
          <ArrowUpRight
            size={22}
            className="opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all text-ash"
          />
        </h3>
        <p className="mt-3 text-ash leading-relaxed max-w-xl">{study.summary}</p>
        <div className="mt-4 flex flex-wrap gap-2">
          {(study.tags || []).map((t) => (
            <span key={t} className="rounded-full border border-white/15 px-3 py-1 text-xs text-cream/70">
              {t}
            </span>
          ))}
        </div>
      </div>

      <div className="md:col-span-4 flex gap-8 md:justify-end">
        {(study.metrics || []).slice(0, 2).map((m, i) => (
          <div key={i}>
            <p className="font-heading font-light text-3xl tracking-tight text-cream">{m.value}</p>
            <p className="text-ash text-xs mt-1 max-w-[7rem]">{m.label}</p>
          </div>
        ))}
      </div>
    </Link>
  );
};

export default CaseStudyRow;
